import { Injectable } from '@angular/core';
import { LoggingService } from '@app-core';
import { Subject } from 'rxjs';

export interface SelectedFiles {
    name?: string;
    file?: any;
    base64?: string;
    url?: string;
}

@Injectable({
    providedIn: 'root',
})
export class FileUtilityService {
    constructor() {}

    public toBase64(files: File[], selectedFiles: SelectedFiles[]): Subject<SelectedFiles[]> {
        const result = new Subject<SelectedFiles[]>();
        if (files?.length) {
            Object.keys(files)?.forEach((file, i) => {
                const url = URL.createObjectURL(files[i]);
                let fileCount = 0;
                const reader = new FileReader();
                reader.readAsDataURL(files[i]);
                reader.onload = (e) => {
                    LoggingService.log('toBase64: loaded: ' + files[i]?.name);
                    const base64textString = window.btoa(reader?.result as string);
                    selectedFiles.push({ name: files[i]?.name, file: files[i], base64: base64textString, url: url });
                    LoggingService.log('tobase64 ' + selectedFiles[i]?.url);
                    result.next(selectedFiles);
                    fileCount = fileCount + 1;
                    if (fileCount >= files.length) {
                        result.complete();
                    }
                };
            });
            return result;
        } else {
            result.next([]);
            result.complete();
            return result;
        }
    }
}
